export const menuByCategory = {
  starters: {
    title: "Starters / Appetizers",
    tabs: ["Snacks", "Starters"],
    items: [
      {
        tab: "Snacks",
        name: "Mixed Nuts",
        price: 3.5,
        description: "A selection of premium mixed nuts.",
      },
      {
        tab: "Snacks",
        name: "Termos (Lupin Beans)",
        price: 4,
        description: "Freshly salted lupin beans.",
      },
      {
        tab: "Snacks",
        name: "Nachos",
        price: 15,
        description: "Cheese sauce, jalapeño, salsa, crispy nachos.",
      },
      {
        tab: "Starters",
        name: "Special Lebanese Appetizer Mix",
        price: 14,
        description: "A special mix of Lebanese appetizers.",
      },
      {
        tab: "Starters",
        name: "French Fries",
        price: 7,
        description: "Crispy golden fries served with ketchup.",
      },
      {
        tab: "Starters",
        name: "Kebbeh",
        price: 7,
        description: "Traditional Lebanese kebbeh.",
      },
      {
        tab: "Starters",
        name: "Rkakat Jebneh",
        price: 7,
        description: "Crispy cheese rolls.",
      },
      {
        tab: "Starters",
        name: "Special Sabanekh",
        price: 8,
        description: "Special spinach Lebanese starter.",
      },
      {
        tab: "Starters",
        name: "Warak Enab Grand Platter",
        price: 7,
        description: "Stuffed grape leaves grand platter.",
      },
    ],
  },
saj: {
  title: "Saj",
  tabs: ["Saj Menu"],
  image: "/images/saj-category.jpeg",
  items: [
    {
      tab: "Saj Menu",
      name: "Saj Zaatar",
      price: 3,
      description: "Traditional saj bread topped with zaatar.",
    },
    {
      tab: "Saj Menu",
      name: "Saj Jebneh",
      price: 4.5,
      description: "Freshly baked saj with melted cheese.",
    },
    {
      tab: "Saj Menu",
      name: "Saj Zaatar & Jebneh",
      price: 4,
      description: "A delicious combination of zaatar and cheese.",
    },
    {
      tab: "Saj Menu",
      name: "Saj Kawarma",
      price: 4.5,
      description: "Traditional saj topped with flavorful kawarma.",
    },
    {
      tab: "Saj Menu",
      name: "Saj Nutella",
      price: 4.5,
      description: "Warm saj bread filled with Nutella.",
    },
  ],
},
  international: {
    title: "International Cuisine",
    tabs: ["Salads", "Pizza", "Main Dishes"],
    items: [
      {
        tab: "Salads",
        name: "Volcano Crab Salad",
        price: 14,
        description: "Iceberg lettuce, mixed greens, arugula, crab sticks, grated carrots, fresh orange, apple, seasonal fruits, tossed in lemon oil and topped with lemon mayo sauce.",
        image: "/images/volcano-crab.jpeg",
      },
      {
        tab: "Salads",
        name: "Caesar Salad",
        price: 12,
        description: "Romaine lettuce, grilled chicken breast, croutons, parmesan cheese, and classic Caesar dressing.",
        image: "/images/Ceaser.jpeg",
      },
      {
        tab: "Pizza",
        name: "Margarita Pizza",
        price: 9,
        description: "Tomato sauce, mozzarella cheese, fresh basil.",
        image: "/images/Margerita-pizza.jpeg",
      },
      {
        tab: "Pizza",
        name: "Vegetarian Pizza",
        price: 9,
        description: "Tomato sauce, mozzarella cheese, mushrooms, bell peppers, onions, olives.",
        image: "/images/vegiterian-piiza.jpeg",
      },
      {
        tab: "Pizza",
        name: "Pepperoni Pizza",
        price: 10,
        description: "Tomato sauce, mozzarella cheese, and pepperoni slices.",
        image: "/images/Perperoni-pizza.jpeg",
      },
      {
        tab: "Main Dishes",
        name: "Escalope Chicken",
        price: 12,
        description: "Breaded chicken escalope served with french fries and coleslaw salad.",
        image: "/images/Escalop.jpeg",
      },
      {
        tab: "Main Dishes",
        name: "Crispy Chicken",
        price: 12,
        description: "Golden crispy chicken strips served with french fries, coleslaw, and dipping sauce.",
        image: "/images/crispy.jpeg",
      },
      {
        tab: "Main Dishes",
        name: "Seafood Mix",
        price: 16,
        description: "Breaded and fried shrimps, calamari, crab, and fish fingers, served with french fries and dipping sauce.",
        image: "/images/Seafood-mix.jpeg",
      },
      {
        tab: "Main Dishes",
        name: "Creamy Chicken Mushroom",
        price: 15,
        description: "Grilled chicken breast served with creamy mushroom sauce, french fries, and sautéed vegetables.",
        image: "/images/creamy-checkin-mashroum.jpeg",
      },
    ],
  },

 coffee: {
  title: "Coffee Menu",
  tabs: ["Hot Coffee", "Iced Coffee"],

  items: [
    // HOT COFFEE
    {
      tab: "Hot Coffee",
      name: "Espresso",
      price: 2.8,
      description: "Rich and intense Italian-style coffee shot.",
      image: "https://images.unsplash.com/photo-1510707577719-ae7c14805e3a",
    },
    {
      tab: "Hot Coffee",
      name: "Lungo",
      price: 4,
      description: "Extended espresso with a smooth finish.",
      image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085",
    },
    {
      tab: "Hot Coffee",
      name: "Americano",
      price: 5,
      description: "Espresso diluted with hot water.",
      image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93",
    },
    {
      tab: "Hot Coffee",
      name: "Cappuccino",
      price: 5,
      description: "Espresso topped with steamed milk and foam.",
      image: "https://images.unsplash.com/photo-1534778101976-62847782c213",
    },
    {
      tab: "Hot Coffee",
      name: "Mocha",
      price: 6,
      description: "Espresso blended with chocolate and milk.",
      image: "https://images.unsplash.com/photo-1572442388796-11668a67e53d",
    },
    {
      tab: "Hot Coffee",
      name: "White Mocha",
      price: 6,
      description: "Espresso blended with white chocolate and milk.",
    },
    {
      tab: "Hot Coffee",
      name: "Hot Chocolate",
      price: 5,
      description: "Creamy chocolate drink served hot.",
      image: "https://images.unsplash.com/photo-1517578239113-b03992dcdd25",
    },
    {
      tab: "Hot Coffee",
      name: "Lebanese Coffee (Rakwa)",
      price: 7,
      description: "Traditional Lebanese coffee prepared in a rakwa.",
      image: "https://images.unsplash.com/photo-1447933601403-0c6688de566e",
    },
    {
      tab: "Hot Coffee",
      name: "Tea Selection",
      price: 4,
      description: "Choose from our premium tea collection.",
      image: "https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2",
    },
    {
      tab: "Hot Coffee",
      name: "Matcha",
      price: 7,
      description: "Premium ceremonial-grade matcha, whisked and steamed.",
    },

    // ICED COFFEE
    {
      tab: "Iced Coffee",
      name: "Iced Matcha Latte",
      price: 7,
      description: "Premium matcha whisked with cold milk over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Vanilla Matcha Latte",
      price: 7,
      description: "Matcha and vanilla syrup with cold milk over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Strawberry Matcha Latte",
      price: 8,
      description: "Matcha layered with strawberry and cold milk over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Mix Berries Matcha Latte",
      price: 8,
      description: "Matcha layered with mixed berries and cold milk over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Americano",
      price: 5,
      description: "Espresso served over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Cold Brew",
      price: 5,
      description: "Slow-steeped coffee with a smooth taste.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Caramel Latte",
      price: 6,
      description: "Espresso, milk, caramel syrup and ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Vanilla Latte",
      price: 6,
      description: "Espresso, milk and vanilla syrup over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Mocha",
      price: 6,
      description: "Espresso, chocolate and milk over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced White Mocha",
      price: 6,
      description: "Espresso, white chocolate and milk over ice.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Caramel Frappe",
      price: 7,
      description: "Blended iced coffee with caramel, whipped to a frothy finish.",
    },
    {
      tab: "Iced Coffee",
      name: "Iced Vanilla Frappe",
      price: 7,
      description: "Blended iced coffee with vanilla, whipped to a frothy finish.",
    },
  ],
},

  beverages: {
    title: "Cocktails & Beverages",
    tabs: ["Cocktails", "Shakes & Smoothies", "Soft Drinks", "Add-ons"],
    items: [
      {
        tab: "Cocktails",
        name: "Virgin Mojito",
        price: 5,
        description: "Fresh mint, lime, sugar, and soda.",
      },
      {
        tab: "Cocktails",
        name: "Virgin Strawberry Mojito",
        price: 5,
        description: "Fresh strawberries, mint, lime, and soda.",
      },
      {
        tab: "Cocktails",
        name: "Strawberry Smile",
        price: 5,
        description: "Refreshing strawberry virgin cocktail.",
      },
      {
        tab: "Cocktails",
        name: "Blue Hawaii",
        price: 5,
        description: "Tropical blue virgin cocktail.",
      },
      {
        tab: "Cocktails",
        name: "Lemonade",
        price: 5,
        description: "Freshly squeezed lemonade.",
      },
      {
        tab: "Cocktails",
        name: "Minted Lemonade",
        price: 5,
        description: "Freshly squeezed lemonade with fresh mint.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Chocolate Milk Shake",
        price: 7,
        description: "Rich and creamy chocolate milkshake.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Vanilla Milk Shake",
        price: 7,
        description: "Classic creamy vanilla milkshake.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Strawberry Milk Shake",
        price: 7,
        description: "Fresh strawberry milkshake.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Strawberry Smoothie",
        price: 7,
        description: "Blended fresh strawberries smoothie.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Mix Berries Smoothie",
        price: 7,
        description: "Blended mix of fresh berries.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Mango Smoothie",
        price: 7,
        description: "Blended fresh mango smoothie.",
      },
      {
        tab: "Shakes & Smoothies",
        name: "Peach Smoothie",
        price: 7,
        description: "Blended fresh peach smoothie.",
      },
      {
        tab: "Soft Drinks",
        name: "Soft Drink",
        price: 2.5,
        description: "Cold and refreshing soft drink.",
      },
      {
        tab: "Soft Drinks",
        name: "Energy Drink",
        price: 5,
        description: "Energizing canned drink.",
      },
      {
        tab: "Soft Drinks",
        name: "Homemade Ice Tea",
        price: 5,
        description: "Homemade ice tea, available in peach or strawberry/mix berries.",
      },
      {
        tab: "Add-ons",
        name: "Add Mexican",
        price: 1,
        description: "Add-on for your homemade ice tea.",
      },
      {
        tab: "Add-ons",
        name: "Add Strawberry Syrup",
        price: 1,
        description: "Add-on for your homemade ice tea.",
      },
      {
        tab: "Soft Drinks",
        name: "Beer",
        price: 5,
        description: "Cold beer.",
      },
      {
        tab: "Soft Drinks",
        name: "Sparkling Water",
        price: 4,
        description: "Chilled sparkling water.",
      },
      {
        tab: "Soft Drinks",
        name: "Small Water Bottle",
        price: 1.1,
        description: "250ml water bottle.",
      },
    ],
  },

  desserts: {
    title: "Desserts",
    tabs: ["Cakes & Sweets"],
    items: [
      {
        tab: "Cakes & Sweets",
        name: "Tiramisu",
        price: 7,
        description: "Classic Italian tiramisu with mascarpone and coffee.",
      },
      {
        tab: "Cakes & Sweets",
        name: "Strawberry Cheesecake",
        price: 7,
        description: "Creamy cheesecake topped with fresh strawberries.",
      },
      {
        tab: "Cakes & Sweets",
        name: "Blueberry Cheesecake",
        price: 7,
        description: "Creamy cheesecake topped with fresh blueberries.",
      },
      {
        tab: "Cakes & Sweets",
        name: "Fondant au Chocolat",
        price: 7,
        description: "Warm chocolate fondant with a melted center.",
      },
      {
        tab: "Cakes & Sweets",
        name: "Kunafa",
        price: 7,
        description: "Traditional Lebanese kunafa with sweet cheese and syrup.",
      },
      {
        tab: "Cakes & Sweets",
        name: "Fruit Platter",
        price: 10,
        description: "A selection of fresh seasonal fruits.",
      },
    ],
  },

  shisha: {
    title: "Shisha",
    tabs: ["Shisha"],
    items: [
      {
        tab: "Shisha",
        name: "Two Apples",
        price: 7.8,
        description: "Classic double apple shisha.",
      },
      {
        tab: "Shisha",
        name: "Lemon and Mint",
        price: 7.8,
        description: "Fresh lemon and mint shisha.",
      },
      {
        tab: "Shisha",
        name: "Blueberry",
        price: 7.8,
        description: "Sweet blueberry shisha.",
      },
      {
        tab: "Shisha",
        name: "Love",
        price: 7.8,
        description: "Signature love mix shisha.",
      },
      {
        tab: "Shisha",
        name: "Ras",
        price: 4,
        description: "Shisha head change.",
      },
      {
        tab: "Shisha",
        name: "Shisha Charge",
        price: 5.5,
        description: "Shisha refill charge.",
      },
      {
        tab: "Shisha",
        name: "Special Two Apples",
        price: 12,
        description: "Special double apple shisha.",
      },
      {
        tab: "Shisha",
        name: "Special Lemon and Mint",
        price: 12,
        description: "Special lemon and mint shisha.",
      },
    ],
  },
};
